import React from 'react';
import type { GlobalInitialStateTypes } from './globalInitialState';

export interface GlobalContextValue extends GlobalInitialStateTypes {}

export const GlobalContext = React.createContext<
	GlobalContextValue | undefined
>(undefined);
